import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { VariationValue } from '@harnessio/ff-javascript-client-sdk';
import { FeatureFlagCollection } from '../../../shared/interfaces/feature-flag.interface';
import { FeatureFlagService } from '../services/feature-flag/feature-flag.service';
import { TranslateService } from '../translate/translate.service';

export type TranslateArgs = Parameters<InstanceType<typeof TranslateService>['instant']>;

export function featureFlagTranslationResolver(
  featureFlag: FeatureFlagCollection,
  enabledKey: string,
  defaultKey: string,
): ResolveFn<TranslateArgs> {
  return (): Observable<TranslateArgs> => {
    const featureFlagService: FeatureFlagService = inject(FeatureFlagService);
    return featureFlagService
      .variation$(featureFlag, false, true)
      .pipe(map((enabled: VariationValue): TranslateArgs => (enabled ? [enabledKey] : [defaultKey])));
  };
}
